import moment from "moment";
import { useState } from "react";
import { Button, Modal } from "react-bootstrap";

import { useDeleteNoteMutation } from "api/memberPortal/notes/notes.api";
import { Note } from "api/memberPortal/notes/notes.types";

interface DeleteNoteModalProps {
  showDeleteModal: boolean;
  setShowDeleteModal: (_show: boolean) => void;
  note: Note;
}

const DeleteNoteModal = ({
  showDeleteModal,
  setShowDeleteModal,
  note,
}: DeleteNoteModalProps) => {
  const [triggerDeleteNote] = useDeleteNoteMutation();
  const [error, setError] = useState<string | null>(null);
  const deleteNote = async (note_id: number) => {
    try {
      await triggerDeleteNote(note_id).unwrap();
      setShowDeleteModal(false);
    } catch (error) {
      console.log("Error deleting note: ", error);
      setError("We encountered an error deleting the note. Please try again.");
    }
  };

  return (
    <Modal
      size="lg"
      show={showDeleteModal}
      onHide={() => setShowDeleteModal(false)}
    >
      <Modal.Header closeButton className="border-0">
        <Modal.Title>Delete Note</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <h4 className="text-center">
          Are You Sure You Want to Delete this note created on: <br />
          {note.submitted_on &&
            moment.utc(note.submitted_on).format("YYYY.MM.DD [at] HHmm")}
        </h4>
        {error && <div className="text-danger text-center">{error}</div>}
        <div className="d-flex justify-content-center mt-4">
          <Button
            variant="primary"
            className="m-1"
            onClick={() => setShowDeleteModal(false)}
          >
            Cancel
          </Button>
          <Button
            variant="danger"
            className="m-1"
            data-cy="delete-note-modal-button"
            onClick={() => deleteNote(note.note_id)}
          >
            Delete
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default DeleteNoteModal;
